export const ALGOLIA_APP_ID = process.env.NEXT_PUBLIC_ALGOLIA_APP_ID ?? ''
export const ALGOLIA_API_KEY = process.env.NEXT_PUBLIC_ALGOLIA_API_KEY ?? ''
export const ALGOLIA_PRODUCTS_INDEX_NAME =
  process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_INDEX_NAME ?? ''
export const ALGOLIA_QUERY_SUGGESTIONS_INDEX_NAME =
  process.env.NEXT_PUBLIC_ALGOLIA_QUERY_SUGGESTIONS_INDEX_NAME ?? ''

export const isAlgoliaIntegrationConfigured: boolean =
  !!ALGOLIA_APP_ID &&
  !!ALGOLIA_API_KEY &&
  !!ALGOLIA_PRODUCTS_INDEX_NAME &&
  !!ALGOLIA_QUERY_SUGGESTIONS_INDEX_NAME

// Attributes the products index is configured to facet on (Algolia panel).
export const ALGOLIA_PRODUCTS_INDEX_FACETS = {
  category: 'category',
  name_short: 'name_short'
} as const

// Algolia data mapping configuration - object IDs are prefixed with the backend model.
export const ALGOLIA_PRODUCT_OBJECT_ID_PREFIX = 'App\\Models\\Product::'
export const ALGOLIA_PRODUCT_SET_OBJECT_ID_PREFIX = 'App\\Models\\ProductSet::'
